import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "parseMention",
})
export class ParseMentionPipe implements PipeTransform {
  transform(comment: string, ...args: unknown[]): _MentionElement[] {
    const parsedContent: Array<_MentionElement> = [];
    const mentionRegex = /<mention\b([^>]*)>(.*?)<\/mention>/gs;
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = mentionRegex.exec(comment)) !== null) {
      if (match.index > lastIndex) {
        parsedContent.push({
          type: "text",
          value: comment.substring(lastIndex, match.index),
        });
      }

      const attrs = match[1]; // e.g., data-email="some@email.com"
      const displayName = match[2]; // inner text
      const emailMatch = /data-email="([^"]+)"/.exec(attrs);
      const email = emailMatch ? emailMatch[1] : undefined;

      parsedContent.push({
        type: "mention",
        displayName,
        title: email,
      });

      lastIndex = mentionRegex.lastIndex;
    }

    if (lastIndex < comment.length) {
      parsedContent.push({
        type: "text",
        value: comment.substring(lastIndex),
      });
    }

    return parsedContent;
  }
}

type _MentionElement = {
  type: "text" | "mention";
  value?: string;
  displayName?: string;
  title?: string;
};
